import React from 'react';

import { LayoutContext } from 'providers';

export const useLayout = () => {
  const { state, ...rest } = React.useContext(LayoutContext);

  return {
    isLoading: state.isLoading,
    ...rest,
  };
};
